import { Authority } from '@/shared/security/authority';
/* tslint:disable */
// prettier-ignore

// prettier-ignore
const LicenseData = () => import('@/entities/license-data/license-data.vue');
// prettier-ignore
const LicenseDataUpdate = () => import('@/entities/license-data/license-data-update.vue');
// prettier-ignore
const LicenseDataDetails = () => import('@/entities/license-data/license-data-details.vue');
// prettier-ignore
const PortalInfo = () => import('@/entities/portal-info/portal-info.vue');
// prettier-ignore
const PortalInfoDetails = () => import('@/entities/portal-info/portal-info-details.vue');
// jhipster-needle-add-entity-to-router-import - JHipster will import entities to the router here

export default [
  {
    path: '/license-data',
    name: 'LicenseData',
    component: LicenseData,
    meta: { authorities: [Authority.USER, Authority.USER_READ] },
  },
  {
    path: '/license-data/new',
    name: 'LicenseDataCreate',
    component: LicenseDataUpdate,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/license-data/:licenseDataId/edit',
    name: 'LicenseDataEdit',
    component: LicenseDataUpdate,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/license-data/:licenseDataId/generate',
    name: 'LicenseDataGenerate',
    component: LicenseDataDetails,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/license-data/:licenseDataId/view',
    name: 'LicenseDataView',
    component: LicenseDataDetails,
    meta: { authorities: [Authority.USER, Authority.USER_READ] },
  },
  {
    path: '/portal-info',
    name: 'PortalInfo',
    component: PortalInfo,
    meta: { authorities: [Authority.USER, Authority.USER_READ] },
  },
  {
    path: '/portal-info/:portalInfoId/view',
    name: 'PortalInfoView',
    component: PortalInfoDetails,
    meta: { authorities: [Authority.USER, Authority.USER_READ] },
  },
  // jhipster-needle-add-entity-to-router - JHipster will add entities to the router here
];
